import { ReportPermission } from '@vision/ui/enums';
import {
  Permission,
  ReportChartGroup,
  ReportPermissionsDetailItem,
  ReportsPermissionsTableRow,
} from '@vision/ui/interfaces';
import { checkPermission } from '../permission.utils';

export function filterReportChartsByPermission(reportCharts: ReportChartGroup[], userPermissions: Permission) {
  return reportCharts
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => !item.permission || checkPermission(item.permission, userPermissions)),
    }))
    .filter((group) => group.items.length > 0);
}

export function sortPermissionsByName(a: ReportsPermissionsTableRow, b: ReportsPermissionsTableRow) {
  return (a.name ?? '').localeCompare(b.name ?? '');
}

export function checkReportPermission(permissions: ReportPermissionsDetailItem[], codename: ReportPermission) {
  return permissions.some((permission) => permission.codename === codename);
}

export function createDefaultReportPermission(id: string, name: string): ReportsPermissionsTableRow {
  return {
    id,
    name,
    canCopy: false,
    canDelete: false,
    canEdit: false,
    canShare: false,
    canView: true,
  };
}

export function mapReportPermissions(
  id: string,
  name: string,
  permissions: ReportPermissionsDetailItem[],
): ReportsPermissionsTableRow {
  return {
    id,
    name,
    canCopy: checkReportPermission(permissions, ReportPermission.COPY),
    canDelete: checkReportPermission(permissions, ReportPermission.DELETE),
    canEdit: checkReportPermission(permissions, ReportPermission.UPDATE),
    canShare: checkReportPermission(permissions, ReportPermission.SHARE),
    canView: checkReportPermission(permissions, ReportPermission.SHOW),
  };
}
